import { Button, IconButton, Radio } from '@mui/material';
import React, { useState } from 'react';
import {  ArrowBackOutlined, CircleOutlined, CloseOutlined, ImageOutlined } from '@mui/icons-material';
import ImageUpload from '../reusableComp/ImageUpload'; // Import the ImageUpload component
import SkillsDropdown from './SkillsDropdown';
import Heading from '../reusableComp/Heading';
import { CustomSelect, InputBox } from '../../ButtonsIconsInputs/CustomInputs';
import { CloseIconButton } from '../../ButtonsIconsInputs/IconButtons';
import StanderdConstants from '../../services/StanderdConstants';
import { useLocation, useNavigate } from 'react-router-dom';
import { useToast } from '../../services/useToast';
import Toast from '../reusableComp/Toast';
import useUserId from '../../services/useUserId';

function CreateQuestion({setNewQuestion}) {
    const api_url = process.env.REACT_APP_API_URL;
    const [skill, setSkill] = useState('');
    const [questionType, setQuestionType] = useState('');
    const [question, setQuestion] = useState('');
    const [questionImages, setQuestionImages] = useState([]);
    const [difficulty, setDifficulty] = useState('');
    const [loading, setLoading] = useState(false);
    const [options, setOptions] = useState([{ option: '', image: null, isCorrect: false }]);
    const [freeTypeAnswer, setFreeTypeAnswer] = useState('');
    const [freeTypeImage, setFreeTypeImage] = useState(null);
    const [api_res_status, setApi_res_status] = useState(null);
    const [copyrightcheck, setCopyrightcheck] = useState(false)
    const navigate = useNavigate()
    const location = useLocation()

    const UserId=useUserId()
    const handleImageChange = (e) => {
        const files = Array.from(e.target.files);
        if (files.length + questionImages.length > 10) {
            alert('You can only upload a maximum of 10 images.');
            return;
        }
        setQuestionImages([...questionImages, ...files]);
    };

    const { isVisible, message, type, showToast, pauseHideTimer, resumeHideTimer } = useToast();

    const handleRemoveImage = (index) => {
        const updatedImages = questionImages.filter((_, i) => i !== index);
        setQuestionImages(updatedImages);
    };

    const handleOptionImageChange = (index, image) => {
        const updatedOptions = [...options];
        updatedOptions[index].image = image;
        setOptions(updatedOptions);
    };

    const handleCorrectOptionChange = (index) => {
        const updatedOptions = [...options];
        if (questionType.includes(StanderdConstants.MCQSINGLE)) {
            updatedOptions.forEach((option, i) => {
                option.isCorrect = i === index;
            });
        } else {
            updatedOptions[index].isCorrect = !updatedOptions[index].isCorrect;
        }
        setOptions(updatedOptions);
    };
    const handleSubmit = async () => {
                if (!skill || !questionType || !question || !difficulty) {
            setApi_res_status('Please fill in all required fields.');
            return;
        }
        if(!copyrightcheck){
            showToast('Please check the box to confirm that the question is original.','warning')
            setApi_res_status('Please check the box to confirm that the question is original.'); 
            return       
        }

        if (questionType.includes(StanderdConstants.MCQ)) {
            if (options.some((option) => !option.option && !option.image)) {
                showToast('Please provide at least an option text or an image.', 'warning');
                setApi_res_status('Please provide at least an option text or an image.');
                return;
            }
            
            if (!options.some((option) => option.isCorrect)) {
                showToast('Please mark at least one option as correct.','warning')
                setApi_res_status('Please mark at least one option as correct.');
                return;
            }
        } else {
            if (!freeTypeAnswer) {
                showToast('Please fill in the free text answer.','warning')
                setApi_res_status('Please fill in the free text answer.');
                return;
            }


        }

        setLoading(true);
        const formData = new FormData();
        formData.append('skill', skill);
        formData.append('questionType', questionType);
        formData.append('question', question);
        formData.append('difficulty', difficulty);
        formData.append('UserId',UserId)
        formData.append('CreatedAt',new Date())
        questionImages.forEach((image) => {
            formData.append('questionImages', image);
        });

        if (questionType.includes(StanderdConstants.MCQ)) {
            options.forEach((option, index) => {
                formData.append(`options[${index}][option]`, option.option);
                if (option.image) {
                    formData.append(`optionsimage`, option.image);
                }
                formData.append(`options[${index}][isCorrect]`, option.isCorrect);
            });
        } else {
            formData.append('freeTypeAnswer', freeTypeAnswer);
            if (freeTypeImage) {
                formData.append('freeTypeImage', freeTypeImage);
            }
        }

        try {
            const response = await fetch(`${api_url}/questions_answers`, {
                method: 'POST',
                body: formData,
            });
            const data = await response.json();
            showToast(data.message,data.status)
            setApi_res_status(data.message)
            setNewQuestion?.(data?.FullQuestion);

        } catch (error) {
                        setApi_res_status('something went wrong.');
        } finally {
            setLoading(false);
        }
    };

    const resetForm = () => {
        setSkill('');
        setQuestionType('');
        setQuestion('');
        setQuestionImages([]);
        setOptions([{ option: '', image: null, isCorrect: false }]);
        setFreeTypeAnswer('');
        setFreeTypeImage(null);
        setApi_res_status(null);
        setDifficulty('');
    };

    const TypeOfQuestion = 
    [
        { label: 'Multiple Choice - Single Correct', value: 'mcq-single' },
        { label: 'Multiple Choice - Multiple Correct', value: 'mcq-multiple' },
        { label: 'Free Text', value: 'free' }
    ]

    const difficultyLevelData = [
        { label: 'Easy', value: 'easy' },
        { label: 'Normal', value: 'normal' },
        { label: 'Hard', value: 'hard' }
    ]

    return (
        <div className='bg-gray-100'>
               {location.pathname =='/createQuestion' &&  <IconButton
          onClick={() => {
            navigate(-1);   
          }}
        >
          <ArrowBackOutlined/>
        </IconButton> }
        
        <div className="p-6 bg-gray-100 min-h-screen">
     
             <Toast
            message={message}
            isVisible={isVisible}
            type={type}
            pauseHideTimer={pauseHideTimer}
            resumeHideTimer={resumeHideTimer}
      />

            <div className="lg:w-3/4 mx-auto ">
                <div className='w-full bg-sky-600 rounded-t-md text-gray-50 py-2'>
                    <Heading heading={"Create Question"} />
                </div>
                <div className='p-6 bg-white  rounded-lg shadow-md'>
                    <div className="flex justify-between gap-3 w-full mb-4">
                        <div className='w-1/2'>
                            <CustomSelect
                                className=' w-full'
                                options={TypeOfQuestion}
                                value={questionType}
                                onChange={(e) => setQuestionType(e.target.value)}
                                label='Type Of Question'
                                dataField='value'
                                dataText='label'
                                name='TypeOfQuestion'
                            />
                        </div>

                        <div className='w-1/2'>

                            <CustomSelect
                                className='w-1/2'
                                options={difficultyLevelData}
                                value={difficulty}
                                onChange={(e) => setDifficulty(e.target.value)}
                                label='Question Difficulty'
                                dataField='value'
                                dataText='label'
                                name='QuestionDifficulty'

                            />
                        </div>
                    </div>
                    <div className="relative mb-4">
                        <div className="flex items-center relative mb-2">
                            <InputBox
                                inputLabel="Question"
                                inputValue={question}
                                multiline='true'
                                type='text'
                                onChange={(e) => setQuestion(e.target.value)}
                                className="block w-max"
                                inputId='QuestionInput'

                            />
                            <label className=" cursor-pointer -mb-6 mx-2">
                                <ImageOutlined title='upload image' />
                                <input
                                    type="file"
                                    accept="image/*"
                                    multiple
                                    onChange={handleImageChange}
                                    className="hidden"
                                    id='QuestionThumbnail'


                                />
                            </label>
                        </div>
                        <ImageUpload images={questionImages} onRemove={handleRemoveImage} />
                    </div>

                    {questionType.includes('mcq') && (
                        <div className="  space-y-6 mb-4">
                            {options.map((option, index) => (
                                <div key={index} className="relative">
                                    <div className="flex align-baseline relative mb-4 gap-1">
                                        <Radio
                                            type={questionType === 'mcq-single' ? 'radio' : 'checkbox'}
                                            name="correctOption"
                                            checked={option.isCorrect}
                                            onChange={() => handleCorrectOptionChange(index)}
                                            className=" self-end"
                                            id='mcq-Answer'
                                        />
                                        <div
                                            className="block w-full  self-end  rounded-md mb-3"
                                        >
                                            <InputBox
                                                inputLabel={`Option ${index + 1}`}
                                                inputValue={option.option}
                                                multiline='true'
                                                onChange={(e) => {
                                                    const updatedOptions = [...options];
                                                    updatedOptions[index].option = e.target.value;
                                                    setOptions(updatedOptions);
                                                }}
                                                inputId={`Option ${index + 1}`}
                                            />
                                        </div>
                                        <label className=" cursor-pointer self-end mx-2  mb-3 title='upload image'">
                                            <ImageOutlined />
                                            <input
                                                type="file"
                                                accept="image/*"
                                                onChange={(e) => handleOptionImageChange(index, e.target.files[0])}
                                                className="hidden"
                                                id={`OptionImage-${index + 1}`}
                                            />
                                        </label>
                                        <button className='w-5 border-none mx-2  p-0' onClick={() => setOptions(options.filter((_, i) => i !== index))} ><CloseOutlined className='-mb-3 p-0' /></button>
                                    </div>
                                    {option.image && (
                                        <div className="flex items-center mb-4">
                                            <img
                                                src={URL.createObjectURL(option.image)}
                                                alt={`option ${index}`}
                                                className="w-32 h-32 object-cover rounded-md"
                                            />
                                            <CloseIconButton
                                                action={() => {
                                                    const updatedOptions = [...options];
                                                    updatedOptions[index].image = null; // Correctly update the image in the specific option
                                                    setOptions(updatedOptions);
                                                }}
                                                tooltip="Remove image"
                                                iconColor="text-gray-700"
                                            />
                                        </div>
                                    )}

                                </div>
                            ))}
                            <div className=''>
                                <button id='Add-option'
                                    onClick={() => setOptions([...options, { option: '', image: null, isCorrect: false }])}
                                    className='text-gray-600 ml-2 hover:text-gray-900 border-none'
                                    title='Add option'
                                >
                                    <CircleOutlined fontSize='medium' className='mr-2' /> Add Option
                                </button>
                            </div>

                        </div>
                    )}
                    {questionType === 'free' && (
                        <div>
                            <div className="relative mb-4">
                                <div className="flex items-center relative">
                                    <div className='w-full mr-1'>
                                        <InputBox
                                            inputLabel="Type free text answer"
                                            inputValue={freeTypeAnswer}
                                            onChange={(e) => setFreeTypeAnswer(e.target.value)}
                                            multiline='true'
                                            className="block w-full p-2 pr-14 border border-gray-300 rounded-md"
                                            inputId='freeTypeAnswer'
                                        />
                                    </div>
                                    <label className=" cursor-pointer">
                                        <ImageOutlined />
                                        <input
                                            type="file"
                                            accept="image/*"
                                            onChange={(e) => setFreeTypeImage(e.target.files[0])}
                                            className="hidden"
                                            inputId='FreeAnswerImage'
                                        />
                                    </label>
                                </div>
                            </div>
                            {freeTypeImage && (
                                <div className="flex items-center mb-4">
                                    <img src={URL.createObjectURL(freeTypeImage)} alt="free type answer" className="w-32 h-32 object-cover rounded-md" />

                                    <CloseIconButton action={() => setFreeTypeImage('')} tooltip='remove image' iconColor='text-gray-700' />
                                </div>
                            )}
                        </div>
                    )}

                    <div className="mb-4">
                        <SkillsDropdown skill={skill} setSkill={setSkill} />
                    </div>

                    {api_res_status && (
                        <p className="text-red-700 mb-4 text-center">{api_res_status}</p>
                    )}
                    <div><label><input type='Checkbox' id='TermAndConditions' value={copyrightcheck} onChange={(e,v)=>setCopyrightcheck(e.target.checked)} /> <span>This question was originally formulated by me and does not infringe on any copyright regulations.</span></label></div>
                    <div className="flex justify-between space-x-4">
                        <Button id='resetQuestion' onClick={resetForm} variant="outlined" color="secondary">
                            Reset
                        </Button>
                        <Button id='SubmitQuestion' onClick={handleSubmit} variant="contained" color="primary" disabled={loading}>
                            {loading ? 'Submitting...' : 'Submit'}
                        </Button>
                    </div>
                </div>

            </div>
        </div>
        </div>
    );
}

export default CreateQuestion;
